<template>
  <div class="home_wrap">
    <van-nav-bar
      :title="title"
      left-text=""
      left-arrow
      :fixed="true"
      @click-left="onClickLeft"
    />
    <div class="setting-content">
      <div class="setting-head">
        <div class="setting-head-img">
          <div class="user-avatar">
            <img
              src="../../assets/images/person/avt.png"
              alt=""
            />
          </div>
          <div class="setting-head-vip">
            <img src="../../assets/images/person/vip.png" alt="" />
            <span data-text="1">1</span>
          </div>
        </div>
        <div class="setting-head-txt">
          <span>Configurar</span>
          <div class="setting-head-id">
            <section>ID:</section>
            <span>288963230</span>
            <span>
              <div class="svg_icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="13"
                  viewBox="0 0 26 26"
                  fill="none"
                >
                  <g clip-path="url(#clip0_2451_66248)">
                    <path
                      d="M2.793 24.794C2.44999 24.7937 2.12111 24.6573 1.87865 24.4146C1.6362 24.172 1.5 23.843 1.5 23.5V6.675C1.49961 6.50509 1.53278 6.33678 1.59762 6.17972C1.66246 6.02267 1.75769 5.87997 1.87783 5.75983C1.99798 5.63968 2.14067 5.54446 2.29773 5.47962C2.45478 5.41478 2.62309 5.3816 2.793 5.382H18.323C18.4929 5.3816 18.6612 5.41478 18.8183 5.47962C18.9753 5.54446 19.118 5.63968 19.2382 5.75983C19.3583 5.87997 19.4535 6.02267 19.5184 6.17972C19.5832 6.33678 19.6164 6.50509 19.616 6.675V23.5C19.6169 23.6704 19.5842 23.8393 19.5196 23.997C19.455 24.1546 19.3599 24.298 19.2398 24.4188C19.1196 24.5396 18.9768 24.6355 18.8194 24.7009C18.6621 24.7663 18.4934 24.8 18.323 24.8L2.793 24.794ZM3.44 22.853H17.674V7.325H3.44V22.853ZM21.556 20.59V3.442H8.941C8.6911 3.43066 8.4552 3.3234 8.28236 3.14254C8.10953 2.96169 8.01308 2.72116 8.01308 2.471C8.01308 2.22084 8.10953 1.98031 8.28236 1.79946C8.4552 1.6186 8.6911 1.51134 8.941 1.5H22.529C22.787 1.50237 23.0337 1.60639 23.2155 1.78949C23.3972 1.97259 23.4995 2.21999 23.5 2.478V20.589C23.506 20.7202 23.4853 20.8513 23.4391 20.9743C23.393 21.0973 23.3225 21.2097 23.2317 21.3046C23.141 21.3996 23.0319 21.4752 22.9111 21.5268C22.7904 21.5785 22.6604 21.6051 22.529 21.6051C22.3976 21.6051 22.2677 21.5785 22.1469 21.5268C22.0261 21.4752 21.917 21.3996 21.8263 21.3046C21.7355 21.2097 21.665 21.0973 21.6189 20.9743C21.5727 20.8513 21.552 20.7202 21.558 20.589L21.556 20.59Z"
                      fill=""
                    ></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_2451_66248">
                      <rect width="26" height="26" fill="currentColor"></rect>
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </span>
          </div>
        </div>
      </div>
      <van-form @submit="onSubmit" style="margin-top: 0.8rem">
        <van-row>
          <van-col offset="" span="24">
            <van-field
              v-model="userName"
              placeholder=""
              class="setting-input"
              left-icon="user"
            >
            </van-field>
          </van-col>
          <van-col offset="" span="24">
            <van-field
              v-model="userId"
              placeholder=""
              class="setting-input"
              left-icon="user"
            >
            </van-field>
          </van-col>
          <van-col offset="" span="24">
            <div
              style="
                font-size: 0.3rem;
                margin-top: 0.5rem;
                margin-bottom: 0.12rem;
                color: #fff;
              "
            >
              Selecione a data de nascimento (depois de definida, não pode ser
              modificada)
            </div>
            <van-field
              v-model="time"
              placeholder="Dia Mês Ano"
              class="setting-input"
              @click="showTime"
            >
            </van-field>
          </van-col>
          <van-col offset="" span="24">
          </van-col>
        </van-row>
      </van-form>
      <van-popup v-model="show" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          title="Selecione a data"
          cancel-button-text="Cancelar"
          confirm-button-text="Confirmar"
          :min-date="minDate"
          :max-date="maxDate"
        />
      </van-popup>
    </div>
  </div>
</template>
    <script>
import Vue from "vue";
// import Fetch from "../../utils/fetch";
import {
  NavBar,
  Form,
  Field,
  CellGroup,
  Button,
  Col,
  Row,
  DatetimePicker,
  Popup,
} from "vant";

Vue.use(NavBar)
  .use(Form)
  .use(Field)
  .use(CellGroup)
  .use(Button)
  .use(Col)
  .use(Row)
  .use(DatetimePicker)
  .use(Popup);
export default {
  name: "setting",
  components: {},
  data() {
    return {
      userName: "zoey888",
      userId: "288963230",
      content: "",
      title: "Dados",
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(2021, 0, 17),
      show: false,
      time: "",
    };
  },
  created() {},
  beforeDestroy() {},
  mounted() {},
  methods: {
    onClickLeft() {
      this.$router.push("/person");
    },
    onSubmit() {},
    showTime() {
      this.show = true;
    },
  },
};
</script>
    
    <style lang="less" scoped>
@import "../../assets/css/variables.less";
/deep/ .van-nav-bar {
  background: @secondary-color;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}
/deep/.van-hairline--bottom::after {
  border: none;
}
/deep/.van-cell-group--inset {
  margin: 0;
}
/deep/ .van-field__control {
  color: #fff;
}
/deep/ .van-cell::after {
  border: none;
}
/deep/ .van-field__value {
  display: flex;
  align-items: center;
}
/deep/ .van-field__body {
  flex: 1;
}
/deep/ .van-icon {
  line-height: normal;
}
/deep/ .van-icon:before {
  color: @rechargeColor;
}
/deep/ .van-col--24 {
  margin-bottom: 0.5rem;
}
/deep/.van-picker {
  background-color: @activityColor;
}
/deep/ .van-picker__mask {
  width: 0;
}
/deep/ .van-picker__cancel {
  color: @popupTextColor;
}
/deep/.van-picker__title {
  color: #fff !important;
}
/deep/.van-picker__confirm {
  color: @ButtonColor;
}
/deep/ .van-ellipsis {
  color: @popupTextColor;
}
/deep/.van-picker__frame {
//   background-color: @secondary-color;
}
/deep/ .van-picker-column__item--selected .van-ellipsis {
  color: #fff;
}

.setting-input {
  background-color: @secondary-color!important;
  border: 0.01rem solid @bodercolor !important;
  border-radius: 0.2rem;
  color: #fff;
  font-size: 0.3rem;
  height: 1rem;
  width: 100%;
}
.home_wrap {
  width: 100%;
  min-height: 100vh;
  background-color: @activityColor;
  padding-top: 1.2rem;
}
.setting-content {
  box-sizing: border-box;
  border-radius: 0;
  //   flex: 1;
  margin-bottom: 0;
  overflow: auto;
  margin: 0.2rem 0.2rem 0;
  padding: 0.2rem 0.2rem 0;
  .setting-head {
    display: flex;
    align-items: center;
    font-size: 0.3rem;
    height: 1.1rem;
    margin-bottom: 0.5rem;
    .setting-head-img {
      border-radius: 0.14rem;
      width: 1.5rem;
      position: relative;
      .user-avatar {
        width: 100%;
        height: 100%;
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 100%;
          height: 100%;
          border-radius: 5px;
        }
      }
      .setting-head-vip {
        background: #24b299;
        color: @vipTextMoneyColor!important;
        font-size: 0.3rem;
        text-align: center;
        position: absolute;
        bottom: 0.04rem;
        right: 0;
        height: 0.3rem;
        max-width: 0.66rem;
        min-width: 0.5rem;
        padding: 0 0.035rem;
        border-radius: 0.04rem 0 0.04rem 0;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          height: 0.3rem;
          width: 0.45rem;
          min-width: auto !important;
          margin-top: 0.01rem;
          flex-shrink: 0;
          span {
            font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue,
              Helvetica, Segoe UI, Arial, Roboto, PingFang SC, miui,
              Hiragino Sans GB, Microsoft Yahei, sans-serif;
            background: transparent none repeat 0 0 / auto auto padding-box
              border-box scroll;
            font-size: 0.22rem;
            font-style: italic;
            margin: -0.025rem 0 0 0.01rem;
            transform: scale(0.9);
            display: inline-block;
            font-weight: 700;
            position: relative;
            text-shadow: 0 0.01rem 0 rgba(0, 0, 0, 0.4);
            color: transparent;
          }
          span:before {
            background-clip: text;
            background-image: linear-gradient(
              180deg,
              #f7ea94,
              #e5b952 51%,
              #ce9510
            );
            background-size: cover;
            content: attr(data-text);
            height: 100%;
            left: 0;
            position: absolute;
            text-shadow: none;
            top: 0;
            width: 100%;
            z-index: 0;
            box-sizing: inherit;
            margin: 0;
            padding: 0;
          }
        }
      }
    }
    .setting-head-txt {
      margin-left: 0.4rem;
      font-size: 0.3rem;
      color: @popupTextColor;
      .setting-head-id {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
    }
    .setting-head-txt span:first-child {
      color: @ButtonColor!important;
    }
  }
}
.svg_icon {
  margin-left: 0.2rem;
}
.svg_icon path {
  fill: @ButtonColor;
}
</style>
    